import {
  HTTP_METHOD_GET,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { normalizeBaseHome } from '@/common/normalize/normalize-base-home'
import { API_BASE_URL } from '@/common/constant'
import { HOME_API_ERROR_RESPONSE } from '@/common/resources/home-api-error-response'

export const getViewMoreHomeData = async ({ uiCode = '' }) => {
  try {
    const response = await apiRequest(
      commonRequestInstanceToAxiosRequestInfo({
        url: `${API_BASE_URL}/v1/viewmore/${uiCode}`,
        method: HTTP_METHOD_GET,
        needCommonParams: true,
        needCredential: true,
      }),
    )

    response.data = normalizeBaseHome(response?.data?.data)

    return response
  } catch (e) {
    console.error(`Get View More Home Data Error ${e.message}`)

    return HOME_API_ERROR_RESPONSE
  }
}
